/**
 * L'objectif visé par matière — miroir de `App\Stages\StageSubjectGoals` :
 * quatre crans, du plus modeste au plus ambitieux. Le NOM porte l'envie, la
 * PROMESSE dit le travail — et c'est la promesse qui doit rester tenable,
 * jamais une note garantie. Les slugs sont le contrat avec le backend : ne pas
 * les traduire ici.
 *
 * Né sur le Week-end Réussite, lu par le funnel Rentrée depuis que le curseur
 * y remplace le niveau global : une seule définition, deux funnels.
 */
export const SUBJECT_GOALS = [
    { slug: "declic", name: "Déclic", promise: "On débloque ce qui coince" },
    { slug: "solide", name: "Solide", promise: "La moyenne, sans trembler" },
    {
        slug: "ambitieux",
        name: "Ambitieux",
        promise: "Un cran au-dessus de la classe",
    },
    { slug: "expert", name: "Expert", promise: "On vise le 20/20" },
]

export const SUBJECT_GOAL_DEFAULT = "solide"

export const goalIndexOf = (slug) => {
    const i = SUBJECT_GOALS.findIndex((g) => g.slug === slug)
    return i >= 0
        ? i
        : SUBJECT_GOALS.findIndex((g) => g.slug === SUBJECT_GOAL_DEFAULT)
}
